// import baseUrl from "../../configs/axios"
import { toast } from "react-toastify"
import hostConfig from "@configs/host"
import whitelabelConfig from "@configs/whitelabel"
import { JsonWebTokenError } from "jsonwebtoken"

let websocket

const noSuccessNeeded = [
  "getPlans",
  "getUser"
]

const checkSliceObject = {}

const socketMiddleware =
  ({ getState, dispatch }) =>
  (next) =>
  (action) => {
    switch (action.type) {
      // User request to connect
      case "websocket/connect":
        const jwt = localStorage.getItem("jwt")
        if (jwt === null) {
          window.location.reload()
        }
        // console.log(jwt)
        // Configure the object
        websocket = new WebSocket(
          `${hostConfig.BASE_URL_SOCKET}/ws?token=${jwt}&whitelabel=${whitelabelConfig.WHITELABEL_ID}`
        )

        // Attach the callbacks
        websocket.onopen = () => {
          // toast.success(`You are connected successfully!`)
        }
        websocket.onclose = (event) => {
          if (event.code === 1005) {
            console.log("Socket is closed!")

            // dispatch({ type: "websocket/onclose" })
          } else {
            console.log(
              "Socket is closed Unexpectedly. Reconnect will be attempted in 4 second.",
              event.reason
            )
            toast.error(`Connection failed!`)

            setTimeout(() => {
              dispatch({ type: "websocket/connect" })
            }, 5000)
          }
        }

        websocket.onerror = (error) => {
          console.error(
            "Socket encountered error: ",
            error.message,
            "Closing socket"
          )
          websocket.close()
        }
        websocket.onmessage = (event) => {
          if (event.data.includes("primus::ping::")) {
            websocket.send(event.data.replace("ping", "pong"))
          } else {
            const message = JSON.parse(event.data)
            console.log(message)
            if (message.welcome) {
              dispatch({ type: "websocket/isConnected" })
            }
            if (message.connectionError === "Invalid token.") {
              dispatch({ type: "websocket/disconnect" })
            }
            if (message.error) {
              dispatch({
                type: "websocket/error",
                payload: message.error
              })
              toast.error(`${message.error}`)
              return null
            }
            if (message.action) {
              dispatch({
                type: "websocket/success",
                payload: message
              })
            }

            console.log(checkSliceObject)

            if (message.action) {
              if (message.action === "getUser") {
                dispatch({
                  type: `authentication/${message.action}`,
                  payload: message
                })
                return null
              }
              if (message.action.toLowerCase().includes("stats")) {
                dispatch({
                  type: `statistics/${message.action}`,
                  payload: message
                })
                return null
              } else if (message.action.toLowerCase().includes("withdraw")) {
                dispatch({
                  type: `withdraw/${message.action}`,
                  payload: message
                })
                return null
              } else if (checkSliceObject[message.action]) {
                // console.log("qqqqqqqqqqqqqq")
                // console.log(`${checkSliceObject[message.action]}/${message.action}`)

                dispatch({
                  type: `${checkSliceObject[message.action]}/${message.action}`,
                  payload: message
                })
                return null
              } else {
                dispatch({
                  type: `common/${message.action}`,
                  payload: message
                })
                return null
              }
            }
          }
        }

        break

      // User request to send a message
      case "websocket/send":
        const parsedPayload = JSON.parse(action.payload)
        const payloadAction = parsedPayload.params.action
        checkSliceObject[payloadAction] = parsedPayload.params.slice
        delete parsedPayload.params.slice
        // console.log(JSON.parse(action.payload))
        // console.log(JSON.stringify(parsedPayload))

        websocket.send(JSON.stringify(parsedPayload))

        break

      // User request to disconnect
      case "websocket/disconnect":
        if (websocket) {
          websocket.close()
        }
        localStorage.removeItem("jwt")
        localStorage.clear()
        sessionStorage.clear()
        window.location.reload()
        break

      default:
      // We don't really need the default but ...
      // console.log("default case ( entered no middleware case)")
    }

    return next(action)
  }

export default socketMiddleware
